import { render, staticRenderFns } from "./ComissionsPage.vue?vue&type=template&id=28683990"
import script from "./ComissionsPage.vue?vue&type=script&lang=js"
export * from "./ComissionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports